// Sale ribbon: computes % off from the price already rendered on each product card and
// injects a "Hot Sale X% Off" ribbon. Purely additive - does not modify Craft's core templates.
(function () {
  function parsePrice(text) {
    if (!text) return null;
    var cleaned = text.replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var value = parseFloat(cleaned);
    return isNaN(value) ? null : value;
  }

  function addRibbon(cardBadge, percent) {
    if (cardBadge.querySelector('.sale-ribbon')) return;
    var ribbon = document.createElement('span');
    ribbon.className = 'sale-ribbon';
    ribbon.textContent = 'Hot Sale ' + percent + '% Off';
    cardBadge.appendChild(ribbon);
  }

  function processCard(card) {
    var priceEl = card.querySelector('.price--on-sale');
    if (!priceEl) return;
    var regularEl = priceEl.querySelector('.price-item--regular s, s .price-item--regular, s');
    var saleEl = priceEl.querySelector('.price-item--sale');
    if (!regularEl || !saleEl) return;
    var regular = parsePrice(regularEl.textContent);
    var sale = parsePrice(saleEl.textContent);
    if (!regular || !sale || regular <= sale) return;
    var percent = Math.round(((regular - sale) / regular) * 100);
    if (percent <= 0) return;
    var badge = card.querySelector('.card__badge');
    if (badge) addRibbon(badge, percent);
  }

  function scan() {
    document.querySelectorAll('.card-wrapper, .card').forEach(processCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var observer = new MutationObserver(function () {
    scan();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
